<template>
	<v-row dense class="trained-face-attempt-review">
		<v-col
			v-for="attempt in attempts"
			:key="attempt.id"
			cols="auto"
		>
			<v-card
				outlined
				:color="attempt.id === selectedId ? 'primary' : attempt.isValid ? 'success' : attempt.isInvalid ? 'error' : ''"
				class="trained-face-attempt-review__card pa-1"
				@click="$emit('select', attempt.id)"
			>
				<v-img
					contain
					:src="attempt.previewUrl || attempt.imgBase64"
					width="80"
					height="72"
				></v-img>
				<div class="caption text-center white--text">
					{{ attempt.msg }}
				</div>
			</v-card>
		</v-col>
	</v-row>
</template>

<script>
	export default {
		name: 'TrainedFaceAttemptReview',
		props: {
			attempts: {
				type: Array,
				default: () => [],
			},
			selectedId: {
				type: String,
				default: null,
			},
		},
	}
</script>

<style scoped>
	.trained-face-attempt-review__card {
		cursor: pointer;
		width: 92px;
	}
</style>
